<template>
  <v-col>
    <v-text-field
      v-for="(email, i) in value"
      :rules="rules"
      :key="i"
      :label="'e-post' + (i + 1)"
      v-model="value[i]"
      outlined
    ></v-text-field>
    <v-btn @click="appendEmail" icon><v-icon>mdi-plus</v-icon></v-btn>
    <v-btn @click="removeEmail" icon><v-icon>mdi-minus</v-icon></v-btn>
  </v-col>
</template>

<script>
export default {
  name: "ExtraEmails",
  props: {
    value: Array,
    rules: Array
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    appendEmail() {
      this.result.push("");
    },
    removeEmail() {
      this.result.splice(this.value.length - 1, 1);
    }
  }
};
</script>

<style></style>
